import envConfig from '@hulu/env-config';
import axios from 'axios';

import { authorizationInterceptors } from '../util/axiosInterceptors';

const campaignGraphqlManager = axios.create({
  baseURL: envConfig.REACT_APP_CAMPAIGN_API,
});

campaignGraphqlManager.interceptors.request.use(authorizationInterceptors);

export { campaignGraphqlManager };
